import { useEffect } from "react";

interface UseScrollPositionTrackingInput {
  scrollRef: React.RefObject<HTMLDivElement | null>;
  isAutoScrollingRef: React.RefObject<boolean>;
  pendingScrollRef: React.RefObject<unknown | null>;
  runIdRef: React.RefObject<number>;
  updateNearBottom: () => void;
}

export function useScrollPositionTracking({
  scrollRef,
  isAutoScrollingRef,
  pendingScrollRef,
  runIdRef,
  updateNearBottom,
}: UseScrollPositionTrackingInput): void {
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let rafId: number | null = null;
    const onScroll = () => {
      if (!isAutoScrollingRef.current && pendingScrollRef.current) {
        pendingScrollRef.current = null;
        runIdRef.current += 1;
      }
      if (rafId != null) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        updateNearBottom();
      });
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      el.removeEventListener("scroll", onScroll);
      if (rafId != null) cancelAnimationFrame(rafId);
    };
  }, [
    scrollRef,
    isAutoScrollingRef,
    pendingScrollRef,
    runIdRef,
    updateNearBottom,
  ]);
}
